import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DiscountService } from 'src/app/services/discount.service';

@Component({
  standalone: false,
  selector: 'app-discounts-add',
  templateUrl: './discounts-add.component.html',
})
export class DiscountsAddComponent {
  form: any = {
    name: '',
    discount_type: 1,
    discount_value: '',
    status: 1,
  };
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private discountService: DiscountService,
  ) {}

  submit(): void {
    this.validationTriggered = true;
    if (!this.form.name || this.form.discount_value === '' || this.form.discount_value === null) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      name: this.form.name,
      discount_type: Number(this.form.discount_type),
      discount_value: Number(this.form.discount_value),
      status: Number(this.form.status),
    };

    this.discountService.create(payload).subscribe({
      next: (result) => {
        this.toaster.success('Discount added.');
        this.router.navigate(['/ecomm/discounts', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add discount.');
      },
    });
  }
}
